import { usePersonInfo } from '@/data/Content/PersonInfo';
import { personalizationSizesFromProfile } from '@/data/dpp/sizes';
import { useUser } from '@/data/User';
import { useMemo } from 'react';

export const useRecomPersonalSizes = () => {
	const { user } = useUser();
	const isLoggedIn = !!user?.isLoggedIn;
	const { personInfo, isLoading } = usePersonInfo(isLoggedIn);
	const sizes = useMemo(
		() => personalizationSizesFromProfile(personInfo?.x_userProfileField1),
		[personInfo?.x_userProfileField1]
	);

	return { sizes, loading: isLoggedIn && isLoading };
};
